<div class="dropdown-alert-message" #alertMessage>
  <a role="menuitem" href="{{alertsUrl}}?id={{alert.userAlertDistributionID}}" id="{{alert.userAlertDistributionID}}" class="d-block pt-2 pr-3 pb-1 pl-3">
    <strong>{{alert.subject | alertpreviewellipse}}</strong>
  </a>
  <div class="d-flex justify-content-between pr-3 pb-2 pl-3">
    <!-- There are two different Ng pipes for date formatting. (Refer Angular 2 datePipe bug in IE)-->
    <p class="dropdown-alert-message-date small text-muted m-0">{{ alert.sendTimeEST | date:'MMMM d'}}, {{ alert.sendTimeEST | date:'shortTime'}} </p>
    <div class="dropdown-alert-message-actions">
      <button type="button" class="btn btn-link btn-xs js-dismiss" (click)="markRead(alertMessage); $event.stopPropagation();"
        data-dismiss="alert" attr.aria-describedby="{{alert.userAlertDistributionID}}">
        Dismiss
        <span class="sr-only">alert message</span>
      </button>
    </div>
  </div>
</div>
